module.exports = __webpack_public_path__ + "img/ferd_2kl.bfd34f26.jpg";